module.exports = new __parcel__URL__("edit-btn.d5d3769a.png").toString();